import React, {useContext, useEffect, useState} from 'react'
import ListItem from "@common/ListItem";
import ListGroup from "@common/ListGroup";
import axios from "@common/axios";
import CircularLoader from "@common/CircularLoader";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import {NavigationContext} from "@common/context/NavigationContext";
import {HistoryRounded} from "@mui/icons-material";

const ANNOUNCEMENTS_URL = '/web/ui/view/announcements';

const AnnouncementsNavigation = () => {
    const [unreadMessages, setUnreadMessages] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const { loadShortcutByUrl } = useCurrentShortcut();
    const { setNavVisible } = useContext(NavigationContext);

    useEffect(() => {
        axios.get('/web/ui/message/userMessagesInbox', {params: {pageNumber: 1, pageSize: 20, mailbox: 'INBOX'}})
            .then(response => {
                setUnreadMessages(response.data.currPageContents.filter(message => !message.read));
                setLoading(false);
            });
    }, []);

    const navigateToAnnouncements = () => {
        loadShortcutByUrl(ANNOUNCEMENTS_URL);
        setNavVisible(false);

        if (globalReactFunctions && globalReactFunctions.handleTitleNavMenuClose) {
            globalReactFunctions.handleTitleNavMenuClose();
        }
    };

    if (isLoading) {
        return <CircularLoader pageCentered={false}/>;
    }

    return (
        <ListGroup id={'announcements-notifications-control'} isDisclosureItem={true} title={'Announcements'} itemCount={unreadMessages.length || undefined} disabled={false} startOpen={true}>
            {unreadMessages.length === 0
                ? <li className={'ch-list-item'}><span className={'ch-announcements-empty'}>Nothing new to show</span></li>
                : unreadMessages.map(message => (
                    <ListItem isDisclosureItem={true} className={'ch-link'} key={message.messageId} onClick={navigateToAnnouncements}>
                        {message.subject}
                    </ListItem>
                ))
            }
            <ListItem isDisclosureItem={true} className={'ch-announcements-view-older'} onClick={navigateToAnnouncements}>
                <HistoryRounded fontSize={'small'} aria-hidden={true} />
                View older announcements
            </ListItem>
        </ListGroup>
    );
};

export default AnnouncementsNavigation;
